//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { GalleriesUpdateGalleryNameActionType } from '@galleries/actions/galleriesUpdateGalleryNameActions';
import { GALLERIES_ACTIONS } from '@galleries/constants/galleriesConstants';
import { IGalleriesUpdateGalleryName } from '@galleries/models/galleriesStateModel';

const initialState: IGalleriesUpdateGalleryName = {
  errors: {
    updateGalleryNameError: undefined,
  },
  isUpdatingGalleryName: false,
  galleryNameDraft: '',
};

export default function GalleriesUpdateGalleryReducer(
  state: IGalleriesUpdateGalleryName = initialState,
  action: GalleriesUpdateGalleryNameActionType,
): IGalleriesUpdateGalleryName {
  switch (action.type) {
    case GALLERIES_ACTIONS.REQUEST_UPDATE_GALLERY_NAME: {
      return {
        ...state,
        isUpdatingGalleryName: true,
      };
    }
    case GALLERIES_ACTIONS.RECEIVE_UPDATE_GALLERY_NAME_SUCCEEDED: {
      return {
        ...state,
        isUpdatingGalleryName: false,
      };
    }
    case GALLERIES_ACTIONS.RECEIVE_UPDATE_GALLERY_NAME_FAILED: {
      return {
        ...state,
        errors: {
          ...state.errors,
          updateGalleryNameError: action.error,
        },
        isUpdatingGalleryName: false,
      };
    }
    case GALLERIES_ACTIONS.CLEAR_UPDATE_GALLERY_NAME_ERROR: {
      return {
        ...state,
        errors: {
          ...state.errors,
          updateGalleryNameError: undefined,
        },
      };
    }
    default:
      return state;
  }
}
